<template>
  <!-- Sidebar-->
  <b-collapse v-model="menu_visible" id="sidebar">
    <div class="sidebar-heading">
      <a @click="link_close({ name: 'Main' })" class="more">
        <img src="/img/logo_white.png" />
      </a>
    </div>
    <div class="sidebar-body">
      <ul>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu1'"
                :class="{ active: menu_num === 1 }"
              >
                <i class="material-icons">person</i>
                <span>{{ $t("menu.membership.membership") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu1" v-model="visible1" accordion="my-accordion">
            <div class="collapse-item montserrat">
              <a
                @click="forceRerender({ name: 'MemberList' })"
                :class="{ active: sub_menu_num === 11 }"
                class="more"
              >
                <span>{{ $t("menu.membership.member") }}</span>
              </a>
              <a
                @click="forceRerender({ name: 'OwnerList' })"
                class="more"
                :class="{ active: sub_menu_num === 12 }"
              >
                <span>{{ $t("menu.membership.owner") }}</span>
              </a>
              <a
                @click="forceRerender({ name: 'HandiList' })"
                :class="{ active: sub_menu_num === 13 }"
                class="more"
                ><span>{{ $t("menu.membership.x_handicap") }}</span>
              </a>
              <a
                @click="forceRerender({ name: 'PointList' })"
                :class="{ active: sub_menu_num === 14 }"
                class="more"
                ><span>{{ $t("menu.membership.x_point") }}</span>
              </a>
            </div>
          </b-collapse>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu2'"
                :class="{ active: menu_num === 2 }"
              >
                <i class="material-icons">edit_notifications</i>
                <span>{{ $t("menu.support.support") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu2" v-model="visible2" accordion="my-accordion">
            <div class="collapse-item montserrat">
              <a
                @click="forceRerender({ name: 'PlayerNoticeList' })"
                class="more"
                :class="{ active: sub_menu_num === 21 }"
                ><span>{{ $t("menu.support.notice_member") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'OwnerNoticeList' })"
                class="more"
                :class="{ active: sub_menu_num === 22 }"
                ><span>{{ $t("menu.support.notice_owner") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'AppNoticeList' })"
                class="more"
                :class="{ active: sub_menu_num === 23 }"
                ><span>{{ $t("menu.support.notice_app") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'ResourcesList' })"
                class="more"
                :class="{ active: sub_menu_num === 24 }"
                ><span>{{ $t("menu.support.resources") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'InquiryList' })"
                class="more"
                :class="{ active: sub_menu_num === 25 }"
                ><span>{{ $t("menu.support.inquiry") }}</span></a
              >
            </div>
          </b-collapse>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                @click="link_close({ name: 'CourseList' })"
                :class="{ active: menu_num === 3 }"
              >
                <i class="material-icons">flag</i>
                <span>{{ $t("menu.golfcourse.golfcourse") }}</span>
              </button>
            </div>
          </nav>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                @click="link_close({ name: 'TournamentList' })"
                :class="{ active: menu_num === 4 }"
              >
                <i class="material-icons">emoji_events</i>
                <span>{{ $t("menu.tournament.tournament") }}</span>
              </button>
            </div>
          </nav>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu5'"
                :class="{ active: menu_num === 5 }"
              >
                <i class="material-icons">interests</i>
                <span>{{ $t("menu.event.event") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu5" v-model="visible3" accordion="my-accordion">
            <div class="collapse-item montserrat">
              <a
                @click="forceRerender({ name: 'MiniGameList' })"
                class="more"
                :class="{
                  active:
                    sub_menu_num === 51 ||
                    sub_menu_num === 52 ||
                    sub_menu_num === 53 ||
                    sub_menu_num === 54,
                }"
                ><span>{{ $t("menu.event.minigame") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'MiniGameWinningList' })"
                class="more"
                :class="{ active: sub_menu_num === 55 }"
                ><span>{{ $t("menu.event.minigame_win") }}</span></a
              >
            </div>
          </b-collapse>
        </li>
        <!--         <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                type="button"
                class="navbar-toggler"
                @click="link_close({ name: 'SwingList' } )"
                :class="{ active: menu_num === 6 }"
              >
                <i class="material-icons">video_settings</i>
                <span>{{ $t("menu.swing.swing") }}</span>
              </button>
            </div>
          </nav>
        </li> -->

        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu7'"
                :class="{ active: menu_num === 7 }"
              >
                <i class="material-icons">verified_user</i>
                <span>{{ $t("menu.admin.admin") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu7" v-model="visible4" accordion="my-accordion">
            <div class="collapse-item montserrat">
              <a
                @click="forceRerender({ name: 'ManagerList' })"
                class="more"
                :class="{ active: sub_menu_num === 71 }"
                ><span>{{ $t("menu.admin.admin_list") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'GameDataView' })"
                class="more"
                :class="{ active: sub_menu_num === 72 }"
                ><span>{{ $t("menu.admin.game_data_set") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'TimezoneList' })"
                class="more"
                :class="{ active: sub_menu_num === 73 }"
                ><span>{{ $t("menu.admin.timezonelist") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'SavingtimeList' })"
                class="more"
                :class="{ active: sub_menu_num === 74 }"
                ><span>{{ $t("menu.admin.savingtime") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'GameDataCorrectionList' })"
                class="more"
                :class="{ active: sub_menu_num === 76 }"
                ><span>{{ $t("menu.admin.data_correction") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'BadgeList' })"
                class="more"
                :class="{ active: sub_menu_num === 77 }"
                ><span>{{ $t("menu.admin.badge") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'XpointList' })"
                class="more"
                :class="{ active: sub_menu_num === 78 }"
                ><span>{{ $t("menu.admin.x_point_rule") }}</span></a
              >

              <a
                @click="forceRerender({ name: 'PaymentList' })"
                class="more"
                :class="{ active: sub_menu_num === 79 }"
                ><span>{{ $t("menu.admin.payment") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'BannerWrite' })"
                class="more"
                :class="{ active: sub_menu_num === 75 }"
                ><span>{{ $t("menu.admin.main_banner") }}</span></a
              >
            </div>
          </b-collapse>
        </li>
        <li>
          <nav class="navbar">
            <div class="container-fluid">
              <button
                class="navbar-toggler"
                type="button"
                v-b-toggle="'menu8'"
                :class="{ active: menu_num === 8 }"
              >
                <i class="material-icons">verified_user</i>
                <span>{{ $t("menu.admin.stats") }}</span>
              </button>
            </div>
          </nav>
          <b-collapse id="menu8" v-model="visible5" accordion="my-accordion">
            <div class="collapse-item montserrat">
              <a
                @click="forceRerender({ name: 'ShotStats' })"
                class="more"
                :class="{ active: sub_menu_num === 81 }"
                ><span>{{ $t("menu.admin.shot") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'PlyaerStats' })"
                class="more"
                :class="{ active: sub_menu_num === 82 }"
                ><span>{{ $t("menu.admin.playing_time") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'VenueStats' })"
                class="more"
                :class="{ active: sub_menu_num === 83 }"
                ><span>{{ $t("menu.admin.venue") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'MemberStats' })"
                class="more"
                :class="{ active: sub_menu_num === 84 }"
                ><span>{{ $t("menu.admin.member") }}</span></a
              >
              <a
                @click="forceRerender({ name: 'CourseStats' })"
                class="more"
                :class="{ active: sub_menu_num === 85 }"
                ><span>{{ $t("menu.admin.course") }}</span></a
              >
            </div>
          </b-collapse>
        </li>
      </ul>
    </div>
    <div class="time-zone">
      {{ $t("text.common.standard_time") }}<br />
      {{ timezone_name }} (UTC
      {{ timezone_offset >= 0 ? "+" + timezone_offset : timezone_offset }}:00)
    </div>
  </b-collapse>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      aaa: 0,
      menu: 0,
      loging: this.$store.state.status === "success",
      userid: this.$store.state.userId,
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      menu_visible: true,
      timezone_name: this.$store.state.timezone.timezone_name,
      timezone_offset: this.$store.state.timezone.timezone_offset,
    };
  },
  methods: {
    forceRerender: function (val) {
      if (window.innerWidth < 1000) {
        this.menu_visible = false;
      }

      this.$store.commit("setSearchData", {});
      this.$store.commit("forceRerender");
      this.$router.push(val).catch(() => {});
    },

    check_mobile: function () {
      let filter = "win16|win32|win64|mac|macintel";

      if (navigator.platform) {
        if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
          this.is_mobile = true;
        } else {
          this.is_mobile = false;
        }
      }
    },
    link_close(val) {
      this.visible1 = false;
      this.visible2 = false;
      this.visible3 = false;
      this.visible4 = false;
      this.visible5 = false;
      this.forceRerender(val);
    },
    resizeEvent() {
      //window.addEventListener('resize', this.widthCheck)
    },
    widthCheck() {
      if (window.innerWidth < 1000) {
        this.menu_visible = false;
      } else {
        this.menu_visible = true;
      }
    },
  },
  mounted() {
    if (this.$store.state.status === "success") {
      this.loging = true;
    }
    this.widthCheck();
  },
  beforeDestroy() {
    this.widthCheck();
  },
  created() {
    this.check_mobile();
    this.widthCheck();
    if (this.menu_num === 1) {
      this.visible1 = true;
    } else if (this.menu_num === 2) {
      this.visible2 = true;
    } else if (this.menu_num === 5) {
      this.visible3 = true;
    } else if (this.menu_num === 7) {
      this.visible4 = true;
    } else if (this.menu_num === 8) {
      this.visible5 = true;
    }
  },
  computed: {
    logo: function () {
      // if (this.$route.name === 'Main' || this.$route.name === 'ForgotPassword' || this.last_scroll_position > 0)
      return "/img/logo_black.png";
      // else return '/img/logo_white.png'
    },
    menu_num: function () {
      return this.$route.meta.menu_num || 0;
    },
    sub_menu_num: function () {
      return this.$route.meta.sub_menu_num || 0;
    },
  },
  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        this.widthCheck();
      }
    },
    menu_visible: function () {
      this.$emit("menu_v", this.menu_visible);
    },
  },
};
</script>
